import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";

export default class PaymentPlanSummaryFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  constructor() {
    super({
      myRefName: "paymentPlanSummaryFForm",
    });

    this.addField(
      new FCurrencyFieldMDP({
        dataSelectorKey: "fiPaymentPlanInfoStore.ppCalculator.repaymentAmount",
        label: "Repayment Amount",
        parentMDP: this.childMDP,
        readonly: true,
        boundaryClass: "col-4",
      })
    )
      .addField(
        new FSelectDateFieldMDP({
          dataSelectorKey: "fiPaymentPlanInfoStore.ppCalculator.firstDraftDate",
          label: "SPA start date",
          parentMDP: this.childMDP,
          readonly: true,
          boundaryClass: "col-4",
          pastDaysDisabled: true,
        })
      )
      .addField(
        new FTextFieldMDP({
          dataSelectorKey: "fiPaymentPlanInfoStore.ppCalculator.tenor",
          label: "Tenure",
          parentMDP: this.childMDP,
          readonly: true,
          boundaryClass: "col-4",
        })
      )
      .addField(
        new FCurrencyFieldMDP({
          dataSelectorKey: "fiPaymentPlanInfoStore.ppCalculator.totalMonthlyObligation",
          label: "SPA monthly obligation",
          parentMDP: this.childMDP,
          readonly: true,
          boundaryClass: "col-4",
        })
      )
      .addField(
        new FCurrencyFieldMDP({
          dataSelectorKey: "fiPaymentPlanInfoStore.ppCalculator.msfDraftAmount",
          label: "MSF amount",
          parentMDP: this.childMDP,
          readonly: true,
          boundaryClass: "col-4",
        })
      )
      
      ;
  }
}
